/* global $ */

module.exports = {
    busy : false,

    hideErrorMessage : function() {
        $("#error").fadeOutCss()
    },

    hideSuccessMessage : function() {
        $("#success-popup").fadeOutCss()
    },

    hideMessages : function() {
        this.hideErrorMessage()
        this.hideSuccessMessage()
    },

    showErrorMessage : function(message, applyErrorState = true) {
        if ($.isArray(message)) {
            message = message.map(text => $('<p>').html(text))
        }

        $("#error")
        .children('div').html(message)
        .siblings('button').one('click', this.hideErrorMessage)
        .parent().fadeInCss()

        if (applyErrorState) {
            $('.form-control').addClass('has-error').one('keyup', function() {
                $(this).removeClass('has-error')
            })
        }
    },

    showSuccessMessage : function(message) {
        $("#success-popup")
        .children('div').html(message)
        .siblings('button').one('click', this.hideSuccessMessage)
        .parent().fadeInCss()
    },

    showLoadingState : function() {
        this.busy = true

        $('#submit, .submit').addClass('busy')
    },

    hideLoadingState : function() {
        this.busy = false

        $('#submit, .submit').removeClass('busy')
    }
}



/** WEBPACK FOOTER **
 ** ./js/credentials/utils.js
 **/